import type { CrmIntegrationProvider } from "app/pages/sales-intelligence/domain/crm-integration/types/provider";
import type { PredefinedValueType } from "app/pages/sales-intelligence/sub-modules/management/store/type";

/** @deprecated use CrmIntegrationProvider from `app/pages/sales-intelligence/domain/crm-integration/types/provider` */
export type Integration = CrmIntegrationProvider;

export type IntegrationSyncStatus = "Succeeded" | "Failed" | "InProgress" | "NotIntegrated" | "New";

// TODO remove
export type CrmFieldRawDataType = "string" | "number" | "date" | "datetime" | "bool" | "enumeration";

/** @deprecated use `crmListObjectType` from `app/pages/sales-intelligence/domain/crm-integration/types/object-type.ts` */
export enum CrmListObjectType {
    Accounts = "accounts",
    Leads = "leads",
    Contacts = "contacts",
}

export enum CrmFeedLevel {
    User = "user",
    Account = "account",
}

export enum CRMListObjectsType {
    Accounts = "accounts",
    Leads = "leads",
    AccountsAndLeads = "accountsAndLeads",
    Contacts = "contacts",
    AccountsAndContacts = "accountsAndContacts",
}

export type CrmList = {
    integrationName: CrmIntegrationProvider;
    syncedDomainsCount: number;
    availableDomainsCount: number;
    objectType: CrmListObjectType;
};

export enum CrmIntegrationListStatus {
    NotIntegrated = 0,
    NotActive = 1,
    UnmatchedEmail = 2,
    SyncInProgress = 3,
    Active = 4,
}

export enum CrmImportSetting {
    Monitor = "monitor",
    Exclude = "exclude",
    Display = "display",
}

export type CrmColumnItem = {
    readonly label: string;
    readonly name: string;
    readonly isRequired: boolean;
    readonly isEditable: boolean;
    readonly dataType?: PredefinedValueType;
    readonly pickListItems?: Record<string, string>;
};

export type SignalsApiStatusResponse = {
    lastNotifiedEventDate?: string;
    domainsUpdateDate?: string;
    isDomainsFileProcessing: boolean;
    isWebhooksConfigured: boolean;
    subscribedDomainsCount: number;
    signalsCount: number;
    webhooksCount?: number;
};
